export enum OverviewAssetCategoryStoreModelEnum {
  EvLoad = 'EV_LOAD',
  BaseLoad = 'BASE_LOAD',
  Pv = 'PV',
  GridLoad = 'GRID_LOAD',
  Battery = 'BATTERY',
}

export enum InfrastructureOverviewMicrogridControllerStatusStoreModelEnum {
  NotApplicable = 'NOT_APPLICABLE',
  Online = 'ONLINE',
  Offline = 'OFFLINE',
}

export enum EvTypeStoreModelEnum {
  Van = 'VAN',
  Bus = 'BUS',
  Mixed = 'MIXED',
}

export enum SiteTypeStoreModelEnum {
  Fleet = 'FLEET',
  Public = 'PUBLIC',
}

export enum VehicleOperationalStatusStoreModelEnum {
  Ready = 'READY',
  Charging = 'CHARGING',
  Queued = 'QUEUED',
  Faulted = 'FAULTED',
  InDepot = 'IN_DEPOT',
  OnTheRoad = 'ON_THE_ROAD',
  Unknown = 'UNKNOWN',
}

export enum VehicleEvseCombinedStateStoreModelEnum {
  Available = 'AVAILABLE',
  Charging = 'CHARGING',
  Queued = 'QUEUED',
  Ready = 'READY',
  Faulted = 'FAULTED',
  FaultedUnplugRequired = 'FAULTED_UNPLUG_REQUIRED',
  Maintenance = 'MAINTENANCE',
}

export enum EvseOperationalStateStoreModelEnum {
  Available = 'AVAILABLE',
  Charging = 'CHARGING',
  Queued = 'QUEUED',
  Faulted = 'FAULTED',
  FaultedUnplugRequired = 'FAULTED_UNPLUG_REQUIRED',
  Maintenance = 'MAINTENANCE',
}

export enum EvseStatusStoreModelEnum {
  Charging = 'CHARGING',
  Queued = 'QUEUED',
  Available = 'AVAILABLE',
  Faulted = 'FAULTED',
  Maintenance = 'MAINTENANCE',
  Unknown = 'UNKNOWN',
}

export enum TimelineEntryTypeStoreModelEnum {
  PowerLimitChanged = 'POWER_LIMIT_CHANGED',
  VehiclePluggedIn = 'VEHICLE_PLUGGED_IN',
}

export enum VehicleDetailsWarningStoreModelEnum {
  LateArrival = 'LATE_ARRIVAL',
  PluginAsap = 'PLUGIN_ASAP',
}

export enum VehicleDetailsAlertStoreModelEnum {
  ChargerNotRamping = 'CHARGER_NOT_RAMPING',
  ContactorError = 'CONTACTOR_ERROR',
  PluginOverdue = 'PLUGIN_OVERDUE',
}

export enum DistanceUnitStoreModelEnum {
  Km = 'KM',
  Mile = 'MILE',
}

export enum VehiclesSortByStoreModelEnum {
  OperationalReadyFirst = 'OPERATIONAL_READY_FIRST',
  OperationalOnTheRoadFirst = 'OPERATIONAL_ON_THE_ROAD_FIRST',
  AlphabeticallyAscending = 'ALPHABETICALLY_ASCENDING',
  AlphabeticallyDescending = 'ALPHABETICALLY_DESCENDING',
  SocAscending = 'SOC_ASCENDING',
  SocDescending = 'SOC_DESCENDING',
}

export enum SingleSiteVehiclesViewModeStoreModelEnum {
  Cozy = 'COZY',
  Compact = 'COMPACT',
}

export enum HealthGradeStoreModelEnum {
  Good = 'GOOD',
  Warning = 'WARNING',
  Error = 'ERROR',
}

export enum ConnectorTypeStoreModelEnum {
  Ccs2 = 'CCS2',
  Type2 = 'TYPE_2',
  Chademo = 'CHADEMO',
  Nacs = 'NACS',
  Mcs = 'MCS',
}

export enum OcppChargePointStatusStoreModelEnum {
  Available = 'AVAILABLE',
  Occupied = 'OCCUPIED',
  Preparing = 'PREPARING',
  Charging = 'CHARGING',
  SuspendedEvse = 'SUSPENDED_EVSE',
  SuspendedEv = 'SUSPENDED_EV',
  Finishing = 'FINISHING',
  Reserved = 'RESERVED',
  Unavailable = 'UNAVAILABLE',
  Faulted = 'FAULTED',
}
